import './assets/css/fonts.css';
import './assets/css/index.css';
import './assets/css/loading.css';
import './assets/css/toasts.css';
import './assets/css/tailwind_index.css';

import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import { initDataDog } from './datadog/init.ts';
import { addAppIconsToLibrary } from './icons.ts';
import { testH264Support } from './video-sdk/twilio';

export async function init() {
  initDataDog();
  addAppIconsToLibrary();
  await testH264Support();
  createRoot(document.getElementById('root') as HTMLElement).render(<App />);
}

init();
